import type { ModelAddButtonOptions } from "@/modules/model-add-button";

import InterventionTemplateCreate from "@/features/InterventionTemplates/Create";
import ModelAddButton from "@/modules/model-add-button";

const InterventionTemplateAddButton = (options: ModelAddButtonOptions) => {
  return (
    <ModelAddButton
      model="interventiontemplate"
      component={<InterventionTemplateCreate />}
      {...options}
    />
  );
};

export default InterventionTemplateAddButton;
